/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NatureFxLightningBIcon20Solid = forwardRef('NatureFxLightningBIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M12 2.033c0-1.052-1.334-1.504-1.973-.669l-6.791 8.867a1.1 1.1 0 0 0 .873 1.77H8v5.967c0 1.051 1.334 1.503 1.973.668l6.791-8.867A1.1 1.1 0 0 0 15.891 8H12V2.033Z" })));
});
